import React, {Component} from 'react';
import {FormGroup, Input, Label} from "reactstrap";
import AutoTextarea from "../../forms/AutoTextarea";

class AckResponse extends Component {
  constructor(props) {
    super(props);

  }

  handleInput(comment) {
    this.props.onChangeComment(comment)
  }

  render() {
    return (
      <div>
        {this.props.children}
        {this.props.requireAckResponse && this.props.canAck && (
          <div style={{padding: '20px 30px'}}>
            <FormGroup>
              <Label style={{whiteSpace: 'pre-wrap'}}>Acknowledgement Comment</Label>
              <AutoTextarea
                value={this.props.comment || ""}
                placeholder="Acknowledgement Comment"
                onChange={(value) => this.handleInput(value)}
              />
            </FormGroup>
          </div>
        )}
        {this.props.requireAckResponse && !this.props.canAck && this.props.comment && (
          <div style={{padding: '20px 30px'}}>
            {this.props.acknowledger && (
              <div style={{color: '#7c6408'}}><i>{this.props.acknowledger} Commented</i></div>
            )}
            {!this.props.acknowledger && <b>Acknowledgement Comment</b>}
            <p dangerouslySetInnerHTML={{__html: this.props.comment}}></p>
          </div>
        )}
      </div>
    );
  }
}

export default AckResponse;
